module.exports = __webpack_public_path__ + "img/2-creative-belt-IMG_2351.e1f168a8.png";